import z from "zod";
import { CharterType, DeclarationAutoCreationCondition } from "__generated__/enums";

export const invoiceGroupTypeSchema = z.object({
	id: z.number().nullable(),
	name: z.string().min(1).max(255),
	declarationAutoCreationCondition: z.enum(DeclarationAutoCreationCondition).nullable(),
	charterTypes: z.array(z.enum(CharterType)).min(1),
});

export type InvoiceGroupTypeSchemaInput = z.input<typeof invoiceGroupTypeSchema>;
export type InvoiceGroupTypeSchemaOutput = z.output<typeof invoiceGroupTypeSchema>;

export const invoiceGroupTypeSettingsSchema = z.object({
	advancePayment: z.number().nullable(),
	advancePaymentCorrection: z.number().nullable(),
});

export type InvoiceGroupTypeSettingsSchemaInput = z.input<typeof invoiceGroupTypeSettingsSchema>;
export type InvoiceGroupTypeSettingsSchemaOutput = z.output<typeof invoiceGroupTypeSettingsSchema>;
